var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-picker',{attrs:{"auto-clear":"","accept":"image"},on:{"picked":_vm.picked}},[_vm._t("trigger",null,{"slot":"trigger"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }